import { CheckmarkIcon } from "components/page-components/Icons/small"
import { Link } from "gatsby"
import React from "react"

export const PaywallIllustrationDesk = ({ ZoneOfRequest }) => {
  return (
    <div style={{ display: "grid" }}>
      <svg
        style={{
          gridArea: "1/1",
        }}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 980 440"
      >
        <defs>
          <style>
            {
              ".cls-1{fill:#fff}.cls-2{fill:#034055}.cls-3{fill:#b3cbd4}.cls-4{fill:#ffd62e}"
            }
          </style>
        </defs>
        <path
          className="cls-1"
          d="M830.33 131.65c2 .06-3.82-31-3.68-31.05 7.6-5.25 14.59-15.39 14.59-15.39s14.69 6.08 16.76-6.41c2.68-16.55-.6-24.62-.6-24.62l-44.79-24.35s-25.61 46-10.36 65.28C798.76 99.9 787 119.73 787 119.73l4.52 14.1Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-2"
          d="m822 89.85-2.82-1c-.44 1.06-1.91 2.15-4.18 2.15v2.83c3.26 0 6-1.56 7-3.98ZM842.49 445.83l14.51-208h-91.4l-59.28 188.49s-26.89 7.67-30.86 19.51H485v3h515v-3Zm-36.55-170.09 2.38 154S782.4 435.2 780 445.83h-43.26ZM938 174.83a8 8 0 1 0-8-8 8 8 0 0 0 8 8Zm0-13a5 5 0 1 1-5 5 5 5 0 0 1 5-5Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-3"
          d="M818 28.16c-7.14-47.83-54.34 1.21-13.54 20.38a50.37 50.37 0 0 1 10.28-16s-2.09 17.19 9 22.89 26 7.07 26 7.07-2.42 5.39-6.17 13.24c12.57-2.77 5.66 14.09-3.12 8.13-2.19 4.68-1.86 1.83-3 5 13.27 3.16 22.63-.7 30-19.07 7.3-18.21-12.57-17.81-20.72-40.09C836.63 2.13 818 28.16 818 28.16Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-2"
          d="M817.6 103.83a21.18 21.18 0 0 1-9.77-2.56 22.39 22.39 0 0 1-11.76-14.57c-4.26-15.76 4.94-38.16 15-53.87l2.51 1.6c-9.25 14.48-18.63 36.65-14.61 51.5a19.51 19.51 0 0 0 10.26 12.7c4.89 2.53 9.64 2.9 14.11 1.1 12.37-5 19.15-24.66 19.22-24.86l.27-.8.84-.18c.47-.1 4.63-.89 7 1.48 1.34 1.37 1.71 3.38 1.11 6a6.59 6.59 0 0 1-3.6 4.82c-2.58 1.15-5.64.27-7.27-.38-3.47 6.26-8.94 13.7-16.4 16.7a18.09 18.09 0 0 1-6.85 1.35Zm24.64-20.7c1.31.49 3.26.94 4.64.31a3.67 3.67 0 0 0 1.91-2.78c.37-1.54.25-2.62-.33-3.21-.76-.78-2.36-.84-3.42-.75a63.11 63.11 0 0 1-2.8 6.43Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-2"
          d="m809.1 78.53 5.19-14.35 2.81 1-5.2 14.34Zm22.65-6.7-2.91-.8a6.11 6.11 0 0 0-.67-4.38c-.93-1.45-2.68-2.39-5.17-2.82l.49-3c3.4.57 5.84 2 7.23 4.21a9.13 9.13 0 0 1 1 6.79Zm-26.75-11-3-.64a5.26 5.26 0 0 1 4.06-4.19 7.23 7.23 0 0 1 6.94 2.2l-2.43 1.94a4.15 4.15 0 0 0-3.8-1.12 2.16 2.16 0 0 0-1.77 1.81Z"
          transform="translate(-11.89 -7.83)"
        />
        <circle className="cls-2" cx={794.61} cy={58.5} r={1.5} />
        <circle className="cls-2" cx={811.61} cy={65.5} r={1.5} />
        <path
          className="cls-4"
          d="m666 175.79 87-1.31v65.35h135v-64.76c0-37-9.59-66.6-46.55-65.26l-13.82.5c-1 14.24-18.7 21.92-28.23 21.92-9.2 0-11.75-8.69-8.28-20.48a57.8 57.8 0 0 0-10.58 2.11l-82.38 24.64 5-79.33 1.55-2.11a36.46 36.46 0 0 0-3.91-.23 33.21 33.21 0 0 0-33 30.15l-1.8 88.81Z"
          transform="translate(-11.89 -7.83)"
        />
        <circle className="cls-4" cx={610.11} cy={384} r={6} />
        <circle className="cls-4" cx={759.11} cy={23} r={6} />
        <circle className="cls-4" cx={965.11} cy={172} r={6} />
        <path
          className="cls-2"
          d="M960 129.83v-9h3v9h8v3h-8v8h-3v-8h-9v-3Zm-367 245v-9h3v9h8v3h-8v8h-3v-8h-9v-3Zm184.74-128-3.74-36 88-1v3l-84.7 1 3.4 32.76Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-2"
          transform="rotate(-4.31 716.357 263.009)"
          d="M825.46 100.16h2.98v17.7h-2.98z"
        />
        <path
          className="cls-2"
          d="m701.46 57.21-1.46.13 1.33 17.34 36.67.15-1.18-2.23c-9.33-17.71-27.57-16.08-35.36-15.39Zm2.6 14.48-.88-11.58c7.81-.65 21.58-1 29.74 11.7Z"
          transform="translate(-11.89 -7.83)"
        />
        <path className="cls-2" d="M917.83 419z" />
        <path
          className="cls-2"
          d="M987 259.42a9.68 9.68 0 0 0-8.84-5.58c-6.2-.15-12.56 4.23-16.18 11.23L920.08 350a145.72 145.72 0 0 1 14-33.47c10.66-18.86 14.26-33.64 9.39-38.57a5.25 5.25 0 0 0-2.4-1.39c8.31-7.2 12.2-16.57 10.52-26-1.22-6.84-5.28-12.15-10.54-14 3.56-16.89 1.66-29.65-5.28-35.13-3.86-3-8.82-3.47-13.6-1.17-7.41 3.56-12.2 12.59-12.2 23L912.68 365 898 394.74l8.72 12.09-.63-5.64c0-.22-1.27-13.09 6.72-29.56l.15 8c0 1.39 0 2.75.08 4.06l.66 35 16 8.13-3.21-4.75c-.21-.31-14.62-22.41-9.33-58.27 6.05-9.48 15.32-19.63 29.55-29 13.53-8.88 21-17.53 19.4-22.58a4.29 4.29 0 0 0-.75-1.4c7.7-2.06 13.27-6.92 15.35-13.6 1.52-4.9.72-9.77-2-12.85 10.91-13.44 9.91-21.37 8.29-24.95ZM923.5 203a11.14 11.14 0 0 1 4.77-1.14 9.12 9.12 0 0 1 5.66 1.95c2.92 2.32 9.17 10.22 3.92 33.52l-.33 1.47 1.48.32c4.68 1 8.57 5.83 9.67 12 1.78 10-3.64 20-14.49 26.87l1.5 2.57c1.85-1 4.33-1.88 5.68-.5 2.54 2.56 2 14-9.86 35a144.91 144.91 0 0 0-16 41.09L913 223.31c0-11.31 5.66-18.01 10.5-20.31Zm-20.42 193.69-1.62-2.24 2.41-4.9a61.41 61.41 0 0 0-.79 7.14Zm18.49 22.65-4.91-2.49-.21-11.08a77 77 0 0 0 5.12 13.57Zm56.29-123c-2.18 7-9 11.68-18.28 12.49l.16 3c1.17 0 3.15.13 3.52 1.31.75 2.43-3.47 9.55-18.19 19.22a109.1 109.1 0 0 0-22.49 19.3l42.07-85.23c3.67-7.1 9.34-9.6 13.2-9.6h.22a6.67 6.67 0 0 1 6.2 3.83c1.1 2.44 2.46 9.56-8.75 22.91l-1 1.15 1.16 1c2.64 2.07 3.5 6.38 2.18 10.64Z"
          transform="translate(-11.89 -7.83)"
        />
        <path className="cls-2" d="M894.83 399z" />
        <path
          className="cls-3"
          d="M951 445.83h-80l9.61-105h60.78Z"
          transform="translate(-11.89 -7.83)"
        />
        <path
          className="cls-2"
          d="M788.89 115.48 800 94.28l2.64 1.39-11.11 21.2Z"
          transform="translate(-11.89 -7.83)"
        />
      </svg>

      <div
        style={{
          marginLeft: "3%",
          marginTop: "6.5%",
          border: "3px solid #034055",
          backgroundColor: "white",
          gridArea: "1/1",
          width: "75%",
          height: "fit-content",
        }}
        className="px-5 py-5 has-text-mitternachtsblau"
      >
        <p className="title is-4 is-size-6-mobile has-text-mitternachtsblau">
          Jetzt weiterlesen. Mit der B_I ausschreibungsdatenbank.
        </p>
        <p className="mb-5">
          Als Kunde profitieren Sie vom Zugriff auf über <b>10.000+</b> aktuelle{" "}
          {ZoneOfRequest === 4 ? "Aufträge" : "Ausschreibungen"} für alle
          Leistungen aus ganz Deutschland.
        </p>
        <div className="columns is-vcentered is-variable is-2">
          <div className="column is-narrow py-1 has-text-centered">
            <CheckmarkIcon {...{ color: "#0EAA2D", size: 0.8 }} />
          </div>
          <div className="column py-1">Eigene Suchprofile speichern</div>
        </div>
        <div className="columns is-vcentered is-variable is-2">
          <div className="column is-narrow py-1 has-text-centered">
            <CheckmarkIcon {...{ color: "#0EAA2D", size: 0.8 }} />
          </div>
          <div className="column py-1">
            Automatisch über neue passende Aufträge per E-Mail informiert werden
          </div>
        </div>
        <div className="columns is-vcentered is-variable is-2">
          <div className="column is-narrow py-1 has-text-centered">
            <CheckmarkIcon {...{ color: "#0EAA2D", size: 0.8 }} />
          </div>
          <div className="column py-1">Erinnerung bei Fristen</div>
        </div>
        <div className="mt-4">
          <div className="buttons">
            <a
              className="button is-sonnengelb "
              href={`${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`}
            >
              Jetzt kostenfrei testen
            </a>
            <Link
              className="button is-tertiary"
              to="/ausschreibungsdienste/ausschreibungen"
            >
              Mehr erfahren
            </Link>
          </div>
        </div>
      </div>

      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 49 46"
        width="5%"
        style={{
          transform: "translate(1470%, 408%)",
          gridArea: "1/1",
        }}
      >
        <path
          d="M787.06 241.13h-35.64a13.44 13.44 0 0 1-13.36-13.49v-4.39a13.44 13.44 0 0 1 13.36-13.48h9.67l-3.39-3.84a6.52 6.52 0 0 1 .53-9.16 6.29 6.29 0 0 1 4.26-1.64 6.43 6.43 0 0 1 4.81 2.17l10.5 12.53 9.24.77Zm-35.64-28.33A10.44 10.44 0 0 0 741 223.27v4.39a10.44 10.44 0 0 0 10.38 10.48h32.66V213.4l-7.74-.65-.4-.48-10.86-13a3.46 3.46 0 0 0-2.57-1.15 3.35 3.35 0 0 0-2.27.88 3.51 3.51 0 0 0-.29 4.93l7.8 8.85h-16.29Z"
          transform="translate(-738.06 -195.13)"
          style={{
            fill: "#034055",
          }}
        />
        <path
          d="M751.42 212.78A10.44 10.44 0 0 0 741 223.25v4.39a10.44 10.44 0 0 0 10.38 10.48h32.66v-24.74l-7.74-.65-.4-.48-10.86-13a3.46 3.46 0 0 0-2.57-1.15 3.35 3.35 0 0 0-2.27.88 3.51 3.51 0 0 0-.29 4.93l7.8 8.85h-16.29Z"
          transform="translate(-738.06 -195.13)"
          style={{
            fill: "#fff",
          }}
        />
      </svg>
    </div>
  )
}
